import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  height?: number
  width?: number
  fill: string
}

function Check(props: Props) {
  return (
    <svg
      className={cx(props.className)}
      height={props.height}
      width={props.width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C15.522 0 20 4.47803 20 10C20 15.522 15.522 20 10 20C4.47803 20 0 15.522 0 10C0 4.47803 4.47803 0 10 0ZM14.2727 6.24356C14.7926 6.13877 15.2722 6.04211 15.5059 6.65068C15.6833 7.10211 15.5341 7.58579 15.0867 7.77926C15.0827 7.78329 14.7844 7.91227 14.6232 7.98079V7.98482C14.6232 7.98482 14.6313 7.98482 14.6474 7.98079C14.6474 7.98079 14.6152 7.98885 14.5547 8.01303C14.5345 8.02512 14.5224 8.02916 14.5224 8.02916H14.5104C14.1637 8.1662 13.1682 8.666 11.6768 10.242C9.8776 12.1392 9.4965 13.1101 9.47321 13.1694C9.47255 13.1711 9.47218 13.172 9.47206 13.1722C9.38742 13.5108 9.11334 13.7688 8.7667 13.8292C8.71431 13.8373 8.66191 13.8413 8.61354 13.8413C8.3193 13.8413 8.04119 13.6962 7.87593 13.4463C7.86787 13.4342 7.1867 12.4185 6.437 11.6688C5.70342 10.9312 4.84893 10.4032 4.84087 10.3992C4.42571 10.1412 4.29673 9.59707 4.55066 9.18192C4.80862 8.76273 5.35276 8.63375 5.76791 8.88768C5.80822 8.91186 6.80379 9.52452 7.69456 10.4153C7.98476 10.7015 8.25884 11.0199 8.50068 11.3141C8.89568 10.7337 9.49222 9.97192 10.3991 9.01666C12.5797 6.71114 13.9622 6.30808 14.2725 6.24359L14.2727 6.24356Z"
        fill={props.fill}
      />
    </svg>
  )
}

export default Check
